import pluralize from 'pluralize';
import { memo } from 'react';

import { WorkspaceAgentAssetListRows } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/WorkspaceAgentAssetListRows';
import { type WorkspaceAgentThumbnail } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/workspaceAgentThumbnailTypes';

export type WorkspaceAgentAssetListHoverPanelProps = {
  onOpenThumbnail?: (id: string) => void;
  thumbnails: WorkspaceAgentThumbnail[];
  /** Members the workspace can no longer return; `0` is a real answer, not a missing one. */
  unavailableCount: number;
};

/** Scrollable asset list shown inside the list-pill hover card or scope popover. */
export const WorkspaceAgentAssetListHoverPanel = memo(
  ({ onOpenThumbnail, thumbnails, unavailableCount }: WorkspaceAgentAssetListHoverPanelProps) => {
    const totalLabel = pluralize('asset', thumbnails.length, true);
    const footerLabel = unavailableCount > 0 ? `${totalLabel} · ${unavailableCount} unavailable` : null;

    return (
      <div
        className="w-[min(280px,calc(100vw-2rem))] overflow-hidden"
        data-testid="WORKSPACE_AGENT_ASSET_LIST_HOVER_PANEL"
      >
        <WorkspaceAgentAssetListRows onOpen={onOpenThumbnail} thumbnails={thumbnails} />
        {footerLabel ? (
          <p className="ads:border-default border-gray-5 border-t px-3 py-1.5 ads:text-metadata text-12 text-gray-10">
            {footerLabel}
          </p>
        ) : null}
      </div>
    );
  },
);

WorkspaceAgentAssetListHoverPanel.displayName = 'WorkspaceAgentAssetListHoverPanel';
